export const BASE_URL = "https://ommalashtirish.shinzofamily.uz"

export const CONFIRM = "/auth/confirm/"
export const CONFIRM_RESET = "/auth/confirm/reset/"
export const ERP_REGISTER = "/auth/erp_register/"
export const RESEND = "/auth/resend/"
export const GET_ME = "/auth/me/"
export const RESET_PASSWORD = "/auth/reset/password/"
export const TOKEN = "/auth/token/"
export const TOKEN_REFRESH = "/auth/token/refresh/"
export const TOKEN_VERIFY = "/auth/token/verify"
export const REGISTER = "/auth/register/"

export const ADDRESS = "/address/"
export const APPEALS = "/appeals/"
export const APPEAL_INFO = "/appeal/info/"
export const ADDRESS_DISTRICT = "/address/districts/"
export const ADDRESS_REGIONS = "/address/regions/"
export const DISTRICTS = "/districts/"
export const GENERATE_CERTIFICATES = "/generate_certificates/"
export const GET_OTP = "/get-otp/"
export const GET_CERTIRIFCATE = "/get_certificate/"
export const ORGANIZATION = "/organization/"
export const POSTS = "/posts/"
export const QUESTIONS = "/questions/"
export const REPORT = "/report/"
export const MY_REPORT = "/report/my-report/"
export const SCIENCE = "/sicence/"
export const SCIENCES = "/sicences/"